import { createEnvelopeSource } from './create-envelope-source';

/**
 * Login-retention source (`GET /analytics/login-retention`): of the people who
 * used the full app in the period, how many came back.
 *
 * All three metrics are ratios, so a card carries the active-user base each was
 * divided by. That matters more here than anywhere else on the dashboard: a
 * retention rate that rose because fewer people were active looks identical to
 * one that rose because more of them came back.
 */
export const loginRetentionSource = createEnvelopeSource({
    label: 'Login retention',
    endpoint: 'analytics/login-retention',
    metrics: [
        { id: 'repeatVisitRate', label: 'Repeat visit rate', type: 'ratio' },
        {
            id: 'returningUserRate',
            label: 'Returning user rate',
            type: 'ratio',
        },
        {
            id: 'averageActiveDaysPerUser',
            label: 'Average active days per user',
            type: 'ratio',
        },
    ],
    forms: ['rate', 'number', 'bars'],
    regionGrain: 'province',
});
